import { render, staticRenderFns } from "./RsaGestioneOspitiListArchivioComponent.vue?vue&type=template&id=5d80b29c"
import script from "./RsaGestioneOspitiListArchivioComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiListArchivioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports